import React, {Suspense} from 'react';
import MileageRegister, {MileageRegisterLoading} from '@di-shared/features/mileage/register/MileageRegister';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

interface MileageRegisterPageProps {
  vin: string;
}

function MileageRegisterPage({vin}: MileageRegisterPageProps) {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Suspense fallback={<MileageRegisterLoading />}>
        <MileageRegister vin={vin} />
      </Suspense>
    </div>
  );
}

export default MileageRegisterPage;
